__turbopack_context__.v({
  "className": "barlow_eb33f810-module__4T1AJG__className",
});
